<template>
  <div v-if="data.show && data.content" class="banner-container" :style="bannerStyle">
    <div class="banner-inner">
      <div class="banner-content">
        <Markdown :source="data.content" />
      </div>
      <button class="close-button" aria-label="Banner schließen" @click="$emit('closeBanner')" type="button">
        <em class="mdi mdi-close"></em>
      </button>
    </div>
  </div>
</template>

<script>
import Markdown from "vue3-markdown-it";

export default {
  name: "BannerComponent",
  components: {
    Markdown,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  computed: {
    bannerStyle() {
      return {
        backgroundColor: this.data.background || "#FFF3CD",
        color: this.data.color || "#856404",
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.banner-container {
  position: fixed;
  top: $headerNavHeightMobile;
  inset-inline: 0;
  width: 100%;
  padding: 4px 0;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  z-index: 14;

  @media screen and (min-width: $tabletSize) {
    top: 64px;
    padding: 6px 0;
  }

  @media screen and (min-width: $desktopSize) {
    top: 80px;
  }
}

.banner-inner {
  max-width: 1024px;
  margin: 0 auto;
  padding: 0 16px;
  display: flex;
  align-items: center;
  gap: 10px;
  min-height: 44px;
}

.banner-content {
  flex: 1;
  font-size: 0.88em;
  display: flex;
  align-items: center;

  ::v-deep(p) {
    margin: 0;
    line-height: 1.3;
  }

  @media screen and (min-width: $tabletSize) {
    font-size: 0.92em;
  }
}

.close-button {
  flex-shrink: 0;
  background: none;
  border: none;
  cursor: pointer;
  width: 44px;
  height: 44px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;

  &:hover {
    background-color: rgba(0, 0, 0, 0.1);
  }

  em {
    font-size: 30px;
    line-height: 1;
  }
}
</style>
